module.exports = __webpack_public_path__ + "static/img/年度最佳影像手机.9c7672c5.png";